export interface Alert {
    uuid: string;
    text: string;
    screen?: AlertScreen;
}

export enum AlertScreen {
    OnlineBookingSignin = 'OnlineBookingSignin',
    OnlineBookingNewClientForm = 'OnlineBookingNewClientForm',
    OnlineBookingSelectDateTime = 'OnlineBookingSelectDateTime',
    OnlineBookingNotesAndAgreements = 'OnlineBookingNotesAndAgreements',

    // Intake Form
    IntakeFormCustomer = 'IntakeFormCustomer'
}
